<template>
  <!-- <div class="loginPopUp">
    <div class="bg"></div>
    <div class="body_pop_up">
      <h4>{{ $t('login.heading') }}</h4>
      <div class="first_state" v-show="step == 0">
        <form action="">
          <p>{{ $t('login.provide_phone') }}</p>
          <fieldset>
            <label><span class="hint">{{ $t('login.phone') }}</span>
              <span class="prefix">+380</span><input type="tel" id="tel" autocomplete="off" v-model="loginData.phone" v-mask="'(##) ### ####'" placeholder="(00) XXX XXXX" value="38">
            </label>
          </fieldset>
          <button type="submit" :class="{'active': phoneValid}" @click.prevent="requestSMS">{{ $t('login.next') }}</button>
        </form>
          <p class="error" v-if="tooManySmsRequests">{{ $t('login.too_many_requests') }}</p>
      </div>
    </div>
    <div class="state" v-show="step == 1">
      <h4 class="component_heading">{{ $t('login.heading') }}</h4>
      <p class="back" @click="backToPhone">&lt;&lt; {{ $t('login.back') }}</p>
      <p class="top_p">{{ $t('login.to_phone') }}
        <b>+380 {{ loginData.phone }}</b> {{ $t('login.sent_sms') }}</p>
        <label for="code">
          <p class="input_hint">{{ $t('login.code_from_sms') }}</p>
          <input ref="codeInput" type="number" id="code" autocomplete="off" required="" v-model="loginData.pass" v-mask="'######'">
        </label>
        <p class="error" v-if="codeVerifyErr">{{ $t('login.wrong_code') }}</p>
      <div class="button" type="submit" :class="{'active': passValid}" @click="authorize">{{ $t('login.enter') }}</div>
      <p class="status waiting" v-if="smsStatus.status == 1">{{ $t('login.sms_sent_waiting') }}</p>
      <p class="status success" v-if="smsStatus.status == 2">{{ $t('login.code_delivered') }} <span v-if="smsStatus.hyber_status == 23022">{{ $t('login.in_push') }}</span><span v-if="smsStatus.hyber_status == 23011">{{ $t('login.in_sms') }}</span><span v-if="smsStatus.hyber_status == 23033">{{ $t('login.in_viber') }}</span></p>
      <div class="errors" v-if="smsStatus.status == 3">
        <p class="status error" v-if="resetByBrowserTimeout">{{ $t('login.delivery_service_down') }}</p>
        <p class="status error" v-if="smsStatus.substatus == 35">{{ $t('login.mes_expired') }}</p>
        <p class="status error" v-if="smsStatus.substatus == 37">{{ $t('login.cell_problems') }}</p>
        <div class="button active" style="width: 100%" @click="retry">{{ $t('login.resend_sms') }}</div>
      </div>
      <div class="button active" style="width: 100%" @click="retry" v-if="resetByBrowserTimeout">{{ $t('login.resend_sms') }}</div>
    </div>
  </div> -->
  <div class="login__wrapper">
    <div class="wd login__wd">
      <div class="login__left">
        <div class="login__form">
          <div class="login__left__header">
            <img src="../../assets/img/preloader_dt.svg" class="login__logo">
            <p class="login__heading">{{ $t("login.heading") }}</p>
          </div>
          <div class="login__step1" v-show="step === 0">
            <p class="login__step__heading">{{ $t("login.provide_phone") }}</p>
            <p class="login__step__info">{{ $t("login.here_all") }}</p>
            <p class="login__input__description">{{ $t("login.phone") }}</p>
            <label class="login__label">
              <p class="login__phone__prefix">+380</p><input type="tel" class="login__input login__phone__input" id="tel" autocomplete="off" v-model="loginData.phone" v-mask="'(##) ### ####'" placeholder="(00) XXX XXXX" value="38" @keyup.enter="requestSMS">
            </label>
            <p class="login__codeerr" v-if="tooManySmsRequests">{{ $t('login.too_many_requests') }}</p>
            <p class="login__codeerr" v-if="serviceUnavailable">{{ $t('login.service_unavailable') }}</p>
            <div></div>
            <div class="login__phone__submit" :class="{'active': phoneValid && !smsRequested}" @click.prevent="requestSMS">{{ $t("login.send_code") }}</div>
          </div>
          <div class="login__step2" v-show="step === 1">
            <p class="login__step__heading">{{ $t("login.confirm_phone") }}</p>
            <p class="login__step__info nomargin">{{ $t("login.enter_code") }} </p>
            <div class="login__submitted__phone">
              <p class="login__submitted__phone__val ">+380 {{ loginData.phone }}</p>
              <div class="login__submitted__phone__change" @click="backToPhone">{{ $t("login.change_phone") }}</div>
            </div>
            <p class="login__input__description">{{ $t("login.code_from_sms") }}</p>
            <div class="login__code__inputs__holder" :class="{'err': codeVerifyErr}">
              <input type="tel" class="login__input login__code__input" maxlength="1" ref="code_char0" @keyup.right="focusNext(0)" v-model="code_char0">
              <input type="tel" class="login__input login__code__input" maxlength="1" ref="code_char1" @keyup.right="focusNext(1)" @keyup.8="focusPrev(1)" @keyup.left="focusPrev(1)" v-model="code_char1">
              <input type="tel" class="login__input login__code__input" maxlength="1" ref="code_char2" @keyup.right="focusNext(2)" @keyup.8="focusPrev(2)" @keyup.left="focusPrev(2)" v-model="code_char2">
              <input type="tel" class="login__input login__code__input" maxlength="1" ref="code_char3" @keyup.right="focusNext(3)" @keyup.8="focusPrev(3)" @keyup.left="focusPrev(3)" v-model="code_char3">
              <input type="tel" class="login__input login__code__input" maxlength="1" ref="code_char4" @keyup.right="focusNext(4)" @keyup.8="focusPrev(4)" @keyup.left="focusPrev(4)" v-model="code_char4">
              <input type="tel" class="login__input login__code__input" maxlength="1" ref="code_char5" @keyup.8="focusPrev(5)" @keyup.left="focusPrev(5)" v-model="code_char5">
            </div>
            <p class="login__codeerr" v-if="codeVerifyErr">{{ $t("login.wrong_code") }}</p>
            <div class="login__codestatus" v-if="smsStatus.status == 1 && !resetByBrowserTimeout">
              <img src="/static/img/loading.svg" class="login__codestatus__icon">
              <p class="login__codestatus__text">{{ $t('login.sms_sent_waiting') }}</p></div>
            <div class="login__codestatus" v-if="smsStatus.status == 2">
              <img src="/static/img/done.svg" class="login__codestatus__icon"><p class="login__codestatus__text">{{ $t('login.code_delivered') }} <span v-if="smsStatus.hyber_status == 23022">{{ $t('login.in_push') }}</span><span v-if="smsStatus.hyber_status == 23011">{{ $t('login.in_sms') }}</span><span v-if="smsStatus.hyber_status == 23033">{{ $t('login.in_viber') }}</span></p>
            </div>
            <div class="login__codestatus" v-if="smsStatus.status == 3">
              <img src="/static/img/error.svg" class="login__codestatus__icon">
              <!-- <p class="login__codestatus__text" v-if="resetByBrowserTimeout">{{ $t('login.delivery_service_down') }}</p> -->
              <p class="login__codestatus__text" v-if="smsStatus.substatus == 35">{{ $t('login.mes_expired') }}</p>
              <p class="login__codestatus__text" v-if="smsStatus.substatus == 37">{{ $t('login.cell_problems') }}</p>
            </div>
            <div class="login__resend__code" :class="{'active': resetByBrowserTimeout || smsStatus.status == 3}" @click.prevent="retry">{{ $t('login.resend') }} <span v-if="!resetByBrowserTimeout && !(smsStatus.status == 3)">{{ $t('login.after') }} {{ resendCodeCtr }} сек.</span></div>
          </div>
          <div class="login__step3" v-show="step === 2">
            <p class="login__step__heading">Multiplex всегда с Вами</p>
            <p class="login__step__info mar16">С нашим мобильным приложением билеты всегда под рукой! </p>
            <p class="login__step__info">
              Отправить ссылку на приложение на номер:<br>
              <span class="login__app__phone">+380 {{ loginData.phone }}</span>?
            </p>
            <div class="login__app__buttons">
              <div class="login__app__button yes" @click="requestAppSMS">Да</div>
              <div class="login__app__button no" @click="sendInside">Пропустить</div>
            </div>
          </div>
          <div class="login__nav">
            <div class="login__nav__el" :class="{'active': step === 0}"></div><div class="login__nav__el" :class="{'active': step === 1}"></div><!-- <div class="login__nav__el" :class="{'active': step === 2}"></div> -->
          </div>
        </div>
      </div>
      <div class="login__right">
        <div class="login__promo">
          <img src="/static/img/lk_login_img_new.png" class="login__promo__ill">
          <p class="login__promo__heading">{{ $t("login.no_download_print") }}</p>
          <p class="login__promo__description">{{ $t("login.all_in_cabinet") }}</p>
        </div>
      </div>
    </div>
  </div>
  
</template>
<script>
import Store from '../../store'
export default {
  data: function () {
    return {
      loginData: {
        phone: '',
        pass: ''
      },
      code_char0: '',
      code_char1: '',
      code_char2: '',
      code_char3: '',
      code_char4: '',
      code_char5: '',
      step: 0,
      polling: null,
      pollingTimeout: null,
      resetByBrowserTimeout: false,
      browserTimeout: null,
      smsStatus: {
        status: 1
      },
      codeVerifyErr: false,
      tooManySmsRequests: false,
      tooManeAuthTries: false,
      serviceUnavailable: false,
      resendCodeCtr: 60,
      codeCountDown: null,
      smsRequested: false
    }
  },
  watch: {
    code_char0: function (val) {
      if (val.length > 0) {
        this.$refs['code_char1'].focus()
      }
    },
    code_char1: function (val) {
      if (val.length > 0) {
        this.$refs.code_char2.focus()
      }
    },
    code_char2: function (val) {
      if (val.length > 0) {
        this.$refs.code_char3.focus()
      }
    },
    code_char3: function (val) {
      if (val.length > 0) {
        this.$refs.code_char4.focus()
      }
    },
    code_char4: function (val) {
      if (val.length > 0) {
        this.$refs.code_char5.focus()
      }
    },
    // code_char5: function (val) {
    //   if (val.length > 0) {
    //     this.$refs.code_char1.focus()
    //     console.log(this.fullpass)
    //   }
    // },
    fullpass: function (val) {
      if (val.length === 6) {
        this.authorize()
      }
    }
  },
  computed: {
    fullpass: function () {
      return this.code_char0 + this.code_char1 + this.code_char2 + this.code_char3 + this.code_char4 + this.code_char5
    },
    trimmedPhone: function () {
      // console.log(this.loginData.phone.replace(/[+() ]/g, ''))
      return this.loginData.phone.replace(/[+() ]/g, '')
    },
    phoneValid: function () {
      return this.trimmedPhone.match(/\d{9}/)
    },
    passValid: function () {
      return this.loginData.pass.match(/^\d{6}$/)
    }
  },
  methods: {
    focusNext: function (n) {
      var next = (n + 1).toString()
      this.$refs['code_char' + next].focus()
    },
    focusPrev: function (n) {
      var prev = (n - 1).toString()
      this.$refs['code_char' + prev].focus()
    },
    authorize: function () {
      this.$http.post('https://auth.multiplex.ua/verify', {password: this.fullpass}).then(response => {
        // if (!this.$cookie.get('friends-app-shown')) {
        //   this.$cookie.set('friends-app-shown', 'yes', {expires: 365, domain: '.multiplex.ua'})
        //   this.step = 2
        // } else {
        //   this.sendInside()
        // }
        this.sendInside()
      }, response => {
        if (response.status === 401) {
          this.codeVerifyErr = true
        }
      })
    },
    sendInside: function () {
      clearInterval(this.polling)
      Store.dispatch('getUser', () => {
        Store.dispatch('getDicts', () => {
          this.$router.push('/')
        })
      })
    },
    requestAppSMS: function () {
      alert('SMS REQUESTED')
      this.sendInside()
    },
    requestSMS: function () {
      this.smsRequested = true
      this.tooManySmsRequests = false
      this.serviceUnavailable = false
      this.$http.post('https://auth.multiplex.ua/login', {login: '380' + this.trimmedPhone}).then(response => {
        this.step = 1
        this.smsRequested = false
        if (!response.body.err) {
          this.resetByBrowserTimeout = false
          this.requestSMSStatus()
          this.startCountDown()
          setTimeout(() => {
            this.$refs.codeInput.focus()
          }, 10)
        }
      }, response => {
        this.smsRequested = false
        if (response.status === 401) {
          this.tooManySmsRequests = true
        } else {
          this.serviceUnavailable = true
        }
      })
    },
    startCountDown: function () {
      this.resendCodeCtr = 60
      this.codeCountDown = setInterval(() => {
        this.resendCodeCtr -= 1
        if (this.resendCodeCtr <= 0) {
          this.letResendSMS()
        }
      }, 1000)
    },
    letResendSMS: function () {
      clearInterval(this.codeCountDown)
      this.resetByBrowserTimeout = true
    },
    requestSMSStatus: function () {
      clearInterval(this.polling)
      this.polling = setInterval(() => {
        this.$http.get('https://auth.multiplex.ua/status').then(response => {
          this.smsStatus = response.body
          if (response.body.status !== 1) {
            clearInterval(this.polling)
            clearTimeout(this.browserTimeout)
            this.resetByBrowserTimeout = false
          }
        })
      }, 2000)
      // this.browserTimeout = setTimeout(() => {
      //   this.resetByBrowserTimeout = true
      // }, 20000)
    },
    backToPhone: function () {
      this.step = 0
      clearInterval(this.polling)
      clearTimeout(this.browserTimeout)
    },
    retry: function () {
      clearInterval(this.polling)
      clearTimeout(this.browserTimeout)
      this.requestSMS()
    }
  },
  mounted: function () {
    var ck = this.$cookie.get('UserInfo')
    if (ck) {
      var ckSplit = ck.split('&')
      var ckObj = {}
      for (var i = 0; i < ckSplit.length; i++) {
        var pair = ckSplit[i].split('=')
        ckObj[pair[0]] = pair[1]
      }
      this.loginData.phone = ckObj['UserPhone'].substring(4)
    }
  }
}
</script>



// WEBPACK FOOTER //
// wrapper.vue?01307560